import { render, staticRenderFns } from "./DiscountAddPage.vue?vue&type=template&id=43c83561&scoped=true&"
import script from "./DiscountAddPage.vue?vue&type=script&lang=js&"
export * from "./DiscountAddPage.vue?vue&type=script&lang=js&"
import style0 from "./DiscountAddPage.vue?vue&type=style&index=0&id=43c83561&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c83561",
  null
  
)

export default component.exports